import { format } from "date-fns";
import type { DateArg } from "date-fns";
import { enUS, es } from "date-fns/locale";

import { AVAILABLE_LANGUAGE } from "@/shared/models";
import { getSettingsStoreLanguage } from "@/shared/stores";

const DEFAULT_DATE_FORMAT = "MM/dd/yyyy";

export const formatDate = (
  date: DateArg<Date>,
  dateFormat = DEFAULT_DATE_FORMAT,
) => {
  const language = getSettingsStoreLanguage();
  const locale = language === AVAILABLE_LANGUAGE.ES ? es : enUS;

  return format(date, dateFormat, { locale });
};

const TIME_FORMAT = "hh:mm a";

type THour = `0${1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9}` | `1${0 | 1 | 2}`;
type TMinute = `${0 | 1 | 2 | 3 | 4 | 5}${number}`;
type TPeriod = "AM" | "PM";
type TimeFormat = `${THour}:${TMinute} ${TPeriod}`;

export const formatTime = (date: DateArg<Date>) => {
  return formatDate(date, TIME_FORMAT) as TimeFormat;
};
